// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010930/js/" + chunkId + "." + {"44":"22e56421","225":"a511febb","481":"dc7c0908","486":"3b9cedb8","770":"ba9f0176"}[chunkId] + ".0.699693810481566.chunk.js";
};